import { requiresAuth, requiresTerms } from "@/middleware";

const UsersView = () => import("./UsersView.vue");
const UserDetailsView = () => import("./UserDetailsView.vue");

const userRoutes = [
  {
    path: "/users",
    name: "UsersView",
    component: UsersView,
    meta: {
      middleware: [requiresAuth, requiresTerms]
    }
  },
  {
    path: "/users/:id",
    name: "UserDetails",
    component: UserDetailsView,
    props: true,
    meta: {
      middleware: [requiresAuth, requiresTerms]
    }
  }
];

export default userRoutes;
